import { Col, Form, InputNumber, Button, Select, Tooltip,Row  } from 'antd';
import { rowStyle } from 'shared/styles/baseStyle';
import { PlusSquareFilled } from '@ant-design/icons';

export const layout = {
    labelCol: {
        span: 8,
    },
    wrapperCol: {
        span: 12,
    },
};

export function ParcelAndPacking({isDeviceConfiguration}){
    
    const statusOptions = [
        {
            key: '0',
            name: 'Όλες',
            isActive: !isDeviceConfiguration 
        },
        {
            key: '1',
            name: 'Αρχικοποιημένη',
            isActive: !isDeviceConfiguration 
        },
        {
            key: '2',
            name: 'Μηδενισμένη',
            isActive: true
        },
        {
            key: '3',
            name: 'Προς Μηδενισμό',
            isActive: true
        },
        {
            key: '5',
            name: 'Σε Συμβόλαιο',
            isActive: !isDeviceConfiguration 
        }
    ]
    
    const { Option } = Select;
    return(
        <>
           <Col span={12}>
                <Form.Item
                    name="parcelId"
                    label="Αρ. Κιβωτίου"
                    rules={[{ type: 'number' }]}
                >
                    <InputNumber />
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    name="PackingStatusId"
                    label="Κατάσταση Πακέτου"
                >
                    <Select>
                        {statusOptions.map(status =>
                           status.isActive && <Option key={status.key} value={status.key}>{status.name}</Option>
                        )}
                    </Select>
                </Form.Item>
            </Col>
            <Col span={8} offset={10} >
                <Form.Item >
                    <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                        Αναζήτηση
                    </Button>
                </Form.Item>
            </Col>
        </>
    )
}

export function SearchAndNewPacking ({navigateToNewPackingList}){
    return(
        <>
            <Col offset={22}>
                <Tooltip title="Νέα Εγγραφή">
                    <Button shape="circle" icon={<PlusSquareFilled />} onClick={navigateToNewPackingList} />
                </Tooltip>
            </Col>
            <Row style={rowStyle}>
                <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
            </Row>
        </>
    )
}